export interface ExpenseSheetClass {
AccountEmployeeExpenseSheetId:string
AccountId: number
AccountEmployeeId: number
Description: string
ExpenseSheetDate: Date | undefined
Approved: boolean
Rejected: boolean
Submitted: boolean
InApproval: boolean
CreatedByEmployeeId	: number
CreatedOn: Date | undefined
ModifiedByEmployeeId: number
ModifiedOn: Date | undefined
SubmittedDate: Date | undefined
ApprovedOn	: Date | undefined
ApprovedByEmployeeId: number
RejectedOn: Date | undefined
RejectedByEmployeeId: number
ReimbursementCurrencyId	: number
IsReimbursed: boolean
isSelected: number
CustomField1: string
CustomField2: string
CustomField3: string
CustomField4: string
CustomField5: string
CustomField6: string
CustomField7: string
CustomField8: string
CustomField9: string
CustomField10: string
CustomField11: string
CustomField12: string
CustomField13: string
CustomField14: string
CustomField15: string
}

export interface ExpenseEntryClass{
AccountExpenseEntryId: number
AccountExpenseEntryDate	: Date | undefined
AccountId: number
AccountEmployeeId: number
AccountProjectId: number
AccountExpenseId: number
Description	:string
Amount:number
TeamLeadApproved: boolean
ProjectManagerApproved	: boolean
AdministratorApproved: boolean
Approved: boolean
TimeSheetApprovalPathId	: number
CreatedOn: Date | undefined
CreatedByEmployeeId	: number
ModifiedOn: Date | undefined
ModifiedByEmployeeId: number
IsBillable: boolean
Rejected: boolean
Quantity: number
Rate: number
AmountBeforeTax	:number
TaxAmount: number
Reimburse: boolean
AccountCurrencyId: number
AccountPaymentMethodId: number
AccountBaseCurrencyId: number
ExchangeRate: number
Submitted: boolean
AccountTaxZoneId: number
AccountTimeExpenseBillingExpenseId: string
AccountEmployeeExpenseSheetId: string
OldAccountExpenseEntryId: number
AccountProjectTaskId: number
IsEmailSend	: boolean
AccountClientId: number
AccountExpenseEntryGuidId: string
AccountExpensePolicyPerDiemTypeId:  number
AccountExpensePolicyPerDiemLocationId	: number
isSelected: number
}

export interface ExpensePerdiemClass {
    AccountEmployeeExpenseSheetId:string
    AccountId: number
    AccountEmployeeId: number
    Description: string
    ExpenseSheetDate: Date | undefined
    Approved: boolean
    Rejected: boolean
    Submitted: boolean
    InApproval: boolean
    CreatedByEmployeeId	: number
    CreatedOn: Date | undefined
    ModifiedByEmployeeId: number
    ModifiedOn: Date | undefined
    SubmittedDate: Date | undefined
    ApprovedOn	: Date | undefined
    ApprovedByEmployeeId: number
    RejectedOn: Date | undefined
    RejectedByEmployeeId: number
    ReimbursementCurrencyId	: number
    IsReimbursed: boolean
    isSelected: number
    }

    export interface EmployeeClass {
        AccountEmployeeId: string;
        EmployeeName: string;
    }

    export interface CurrencyClass {
        AccountCurrencyId: number;
        CurrencyCode: string;
        // AccountCurrencyId: number;
        // Currency: string,
        // CurrencyCode: string,
        // CurrencyWithCode: string,
        // ExchangeRate: string
    }

   

export interface MasterDataClass {
    AccountEmployeeExpenseSheetId: string
    EmployeeName: string
    ExpenseSheetDate: Date | undefined
    Status: string
    ReimbursementCurrencyCode: string
    Amount: number
}

export const expenseSheetInitialsForAdd = {
AccountEmployeeId: 0,
Description: "",
ExpenseSheetDate: new Date(),
Approved: false,
Rejected: false,
Submitted: false,
InApproval: false,
SubmittedDate: new Date(),
ApprovedOn: new Date(),
ApprovedByEmployeeId: 0,
RejectedOn: new Date(),
RejectedByEmployeeId:0,
ReimbursementCurrencyId	: 0,
IsReimbursed: false,
CustomField1: '',
CustomField2: '',
CustomField3: '',
CustomField4: '',
CustomField5: '',
CustomField6: '',
CustomField7: '',
CustomField8: '',
CustomField9: '',
CustomField10: '',
CustomField11: '',
CustomField12: '',
CustomField13: '',
CustomField14: '',
CustomField15: ''
}


export const expenseSheetInitialsForUpdate = {
    AccountEmployeeExpenseSheetId:"",
    AccountEmployeeId: 0,
    Description: "",
    ExpenseSheetDate: new Date(),
    Approved: false,
    Rejected: false,
    Submitted: false,
    InApproval: false,
    SubmittedDate: new Date(),
    ApprovedOn: new Date(),
    ApprovedByEmployeeId: 0,
    RejectedOn: new Date(),
    RejectedByEmployeeId:0,
    ReimbursementCurrencyId	: 0,
    IsReimbursed: false,
    CustomField1: '',
    CustomField2: '',
    CustomField3: '',
    CustomField4: '',
    CustomField5: '',
    CustomField6: '',
    CustomField7: '',
    CustomField8: '',
    CustomField9: '',
    CustomField10: '',
    CustomField11: '',
    CustomField12: '',
    CustomField13: '',
    CustomField14: '',
    CustomField15: '',
    AccountId:0, 
    CreatedByEmployeeId:0, 
    CreatedOn:new Date(), 
    ModifiedByEmployeeId:0,
    ModifiedOn:new Date(),
    isSelected:0
}

export const expenseEntryInitialsForAdd = {
    AccountExpenseEntryDate	: new Date(),
    AccountId: 0,
    AccountEmployeeId: 0,
    AccountProjectId: 0,
    AccountExpenseId: 0,
    Description: "",
    Amount: 0,
    TeamLeadApproved: false,
    ProjectManagerApproved	: false,
    AdministratorApproved: false,
    Approved: false,
    TimeSheetApprovalPathId	: 0,
    CreatedOn: new Date(),
    CreatedByEmployeeId	: 0,
    ModifiedOn: new Date(),
    ModifiedByEmployeeId: 0,
    IsBillable: false,
    Rejected: false,
    Quantity: 0,
    Rate: 0,
    AmountBeforeTax	:0,
    TaxAmount: 0,
    Reimburse: false,
    AccountCurrencyId: 0,
    AccountPaymentMethodId: 0,
    AccountBaseCurrencyId: 0,
    ExchangeRate: 0,
    Submitted: false,
    AccountTaxZoneId: 0,
    AccountTimeExpenseBillingExpenseId: "",
    AccountEmployeeExpenseSheetId: 0,
    OldAccountExpenseEntryId: 0,
    AccountProjectTaskId: 0,
    IsEmailSend	: 0,
    AccountClientId: 0,
    AccountExpenseEntryGuidId: "",
    AccountExpensePolicyPerDiemTypeId: 0,
    AccountExpensePolicyPerDiemLocationId:0
    }

    export const expenseEntryInitialsForUpdate = {
        AccountExpenseEntryId : 0,
        AccountExpenseEntryDate	: new Date(),
        AccountId: 0,
        AccountEmployeeId: 0,
        AccountProjectId: 0,
        AccountExpenseId: 0,
        Description: "",
        Amount: 0,
        TeamLeadApproved: false,
        ProjectManagerApproved	: false,
        AdministratorApproved: false,
        Approved: false,
        TimeSheetApprovalPathId	: 0,
        CreatedOn: new Date(),
        CreatedByEmployeeId	: 0,
        ModifiedOn: new Date(),
        ModifiedByEmployeeId: 0,
        IsBillable: false,
        Rejected: false,
        Quantity: 0,
        Rate: 0,
        AmountBeforeTax	:0,
        TaxAmount: 0,
        Reimburse: false,
        AccountCurrencyId: 0,
        AccountPaymentMethodId: 0,
        AccountBaseCurrencyId: 0,
        ExchangeRate: 0,
        Submitted: false,
        AccountTaxZoneId: 0,
        AccountTimeExpenseBillingExpenseId: "",
        AccountEmployeeExpenseSheetId: 0,
        OldAccountExpenseEntryId: 0,
        AccountProjectTaskId: 0,
        IsEmailSend	: 0,
        AccountClientId: 0,
        AccountExpenseEntryGuidId: "",
        AccountExpensePolicyPerDiemTypeId: 0,
        AccountExpensePolicyPerDiemLocationId:0
        }


